/* CaseCrush product interactions.
   Native product form controls remain the source of truth for Shopify and Shiprocket. */
(function () {
  'use strict';

  function getProductForm() {
    return document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function setPhoneError(brand, model, show) {
    var error = document.getElementById('phone-error');
    [brand, model].forEach(function (field) {
      if (!field) return;
      field.classList.toggle('cc-error', show && !field.value);
      field.setAttribute('aria-invalid', show && !field.value ? 'true' : 'false');
    });

    if (error) error.style.display = show ? 'block' : 'none';
  }

  function clickShiprocketWhenReady() {
    return new Promise(function (resolve, reject) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        var button = document.querySelector('.shiprocket-headless[data-type="product"] .sr-headless-checkout, .sr-headless-checkout');
        if (button && !button.disabled) {
          window.clearInterval(timer);
          button.click();
          resolve();
        } else if (attempts >= 40) {
          window.clearInterval(timer);
          reject(new Error('Shiprocket checkout button was not ready.'));
        }
      }, 150);
    });
  }

  function addToCartForCheckout(form) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (url.indexOf('.js') === -1) url += '.js';

    return window.fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add this product to cart.');
      return response.json();
    });
  }

  function bindBuyNow(brand, model) {
    var buyNow = document.getElementById('CaseCrushBuyNow');
    var form = getProductForm();
    if (!buyNow || !form || buyNow.dataset.ccBound === 'true') return;
    buyNow.dataset.ccBound = 'true';

    buyNow.addEventListener('click', function (event) {
      event.preventDefault();

      if ((brand && !brand.value) || (model && !model.value)) {
        setPhoneError(brand, model, true);
        (brand && !brand.value ? brand : model).focus();
        return;
      }

      var addToCart = form.querySelector('button[name="add"]');
      if (!addToCart || addToCart.disabled || buyNow.dataset.loading === 'true') return;

      buyNow.dataset.loading = 'true';
      buyNow.setAttribute('aria-busy', 'true');
      buyNow.disabled = true;

      addToCartForCheckout(form)
        .then(clickShiprocketWhenReady)
        .catch(function () {
          buyNow.disabled = false;
          buyNow.removeAttribute('aria-busy');
          buyNow.dataset.loading = 'false';
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
    });

    // A tap made before this script loaded was parked by the inline script in buy-buttons.liquid.
    if (buyNow.dataset.ccPending === 'true') {
      delete buyNow.dataset.ccPending;
      buyNow.removeAttribute('aria-busy');
      buyNow.click();
    }
  }

  function createStickyCta() {
    if (document.querySelector('.cc-sticky-cta')) return;

    var sourceButton = document.getElementById('CaseCrushBuyNow');
    var price = document.querySelector('.product .price__regular .price-item--regular, .product .price__sale .price-item--sale');
    if (!sourceButton || !price) return;

    var bar = document.createElement('div');
    bar.className = 'cc-sticky-cta';
    bar.innerHTML = '<div class="cc-sticky-cta__price"></div><button class="cc-sticky-cta__button" type="button">Buy now</button>';
    bar.querySelector('.cc-sticky-cta__price').textContent = price.textContent.trim();
    bar.querySelector('.cc-sticky-cta__button').addEventListener('click', function () {
      sourceButton.click();
    });
    document.body.appendChild(bar);
  }

  /* Collection/search grid cards: when the customer's cart already carries a
     selected 'Phone Model' attribute (set by the site-wide phone-select gate)
     and this product has a matching in-stock variant, card-product.liquid
     renders a plain product-form with that variant's id already filled in —
     that should submit and add to cart normally, same as the product page.
     Only the "Choose options" path (modal-opener, shown when there's no
     match — ambiguous which variant to add) needs to send the customer to
     the product page to pick manually. Dawn's quick-add button calls
     preventDefault() before any native "submit" event fires, so a submit
     listener never sees it — intercept the click itself, in the capture
     phase, before Dawn's own handler runs, but only for the modal-opener
     case. */
  function guardQuickAdd() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.quick-add__submit, [id^="quick-add-"][type="submit"]');
      if (!btn) return;
      if (!btn.closest('modal-opener')) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var card = btn.closest('.card-wrapper, .product-card-wrapper, quick-add-modal, li.grid__item');
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      if (link) window.location.href = link.href;
    }, true);
  }

  function init() {
    if (!document.body.classList.contains('template-product')) return;

    // The legacy #phone-brand/#phone-model picker only renders for products
    // without a "Phone Model" variant option. Products with real phone-model
    // variants use the variant picker, whose selection already drives the
    // form's variant id, so Buy Now must bind either way (brand/model may be null).
    var brand = document.getElementById('phone-brand');
    var model = document.getElementById('phone-model');
    bindBuyNow(brand, model);
    createStickyCta();
  }

  guardQuickAdd();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
